<template>
  <DataTable :data-model="'consultingrooms'"
             :display-name-plural="$t('entities.ConsultingRoom.Plural')"
             :display-name-singular="$t('entities.ConsultingRoom.Singular')"
             :permission-name="'ConsultingRooms'"
             :allow-delete="false"
             :exclude-fields="['id', 'doctorId']">
    <template #cell(isEnabled)="row">
      {{ $t('common.'+row.item.isEnabled) }}
    </template>
  </DataTable>
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  }
};
</script>
<style scoped></style>
